import Login from "../pages/auth/Login";
import OnBoarding from "../pages/auth/OnBoarding";
import Register from "../pages/auth/Register";
import UpdatePassword from "../pages/auth/UpdatePassword";
import Dashboard from "../pages/dashboard/Dashboard";
import Home from "../pages/Home";
import KYCPending from "../pages/kycPending";
import Payments from "../pages/Payments";

export const routes = [
  {
    path: "login",
    component: Login,
    isPrivate: false,
  },
  {
    path: "signup",
    component: Register,
    isPrivate: false,
  },
  {
    path: "update-password",
    component: UpdatePassword,
    isPrivate: false,
  },
  {
    path: "/",
    component: Home,
    // isPrivate: false,
  },
  {
    path: "/dashboard",
    component: Dashboard,
    isPrivate: true,
  },
  {
    path: "onboarding",
    component: OnBoarding,
    isPrivate: true,
  },
  {
    path: "/kyc-pending",
    component: KYCPending,
    isPrivate: true,
  },
  {
    path: "/payments",
    component: Payments,
    isPrivate: true,
  },
];
